/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function() {

    // SHow more button animations
    var showMoreButtons = document.querySelectorAll('.show-more-button');

    function slideUp(element, duration = 300) {
        element.style.transition = `height ${duration}ms`;
        element.style.height = `${element.scrollHeight}px`;
        requestAnimationFrame(() => {
            element.style.height = '0';
        });
        setTimeout(() => {
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('transition');
        }, duration);
    }

    function slideDown(element, duration = 300) {
        element.style.display = 'block';
        const height = element.scrollHeight;
        element.style.height = '0';
        element.style.transition = `height ${duration}ms`;
        requestAnimationFrame(() => {
            element.style.height = `${height}px`;
        });
        setTimeout(() => {
            element.style.removeProperty('height');
            element.style.removeProperty('transition');
        }, duration);
    }

    if (showMoreButtons.length > 0) {
        showMoreButtons.forEach(function(button) {
            button.addEventListener('click', function() {

                var moreText = button.previousElementSibling;
                if (moreText && moreText.classList.contains('more-text')) {
                    if (button.classList.contains('show_open')) {
                        button.classList.remove('show_open');
                        button.textContent = 'Show more';
                        slideUp(moreText);
                    } else {
                        button.classList.add('show_open');
                        button.textContent = 'Show less';
                        slideDown(moreText);
                    }
                }
            });
        });
    }

    // Appearance animations
    var mm = gsap.matchMedia();

    mm.add("(min-width: 1025px)", () => {
        // GSAP proces steps animations
        var processContainer = document.querySelector('.wp-block-create-block-mq20-mobile-services');
        var processHeadingSimple = document.querySelector('.mobile-services-header-simple h2');
        var processHeadingAnimated = new SplitType(processHeadingSimple);

        var processHeadingAppearance = document.querySelectorAll('.mobile-services-header-appearance h2');

        var processItemsContainer = document.querySelector(".mobile-services-items");
        var processItems = gsap.utils.toArray(".mobile-services-items .mobile-services-item");

        function initProcessScrollAnimation() {

            if(processHeadingAnimated){
                gsap.fromTo(processHeadingAnimated.chars, {
                    y: 20,
                    opacity: 0
                }, {
                    y: 0,
                    opacity: 1,
                    ease: "power3.inOut",
                    stagger: 0.01,
                    scrollTrigger: {
                        trigger: processContainer,
                        start: "top +=85%",
                        end: "bottom bottom"
                    }
                });
            }

            const theme = document.getElementsByClassName('wp-block-create-block-mq20-mobile-services')[0].getAttribute('data-bg');

            let bgColor, fgColor;
            if (theme === 'light') {
                bgColor = "#D2D3D6";
                fgColor = "#181A1F";
            } else {
                bgColor = "#5E616B";
                fgColor = "#ffffff";
            }

            if(processHeadingAppearance){
                processHeadingAppearance.forEach((char, i) => {
                    const text = new SplitType(char, { types: "words, chars" });

                    gsap.fromTo(
                        text.chars,
                        {
                            color: bgColor
                        },
                        {
                            color: fgColor,
                            duration: 1,
                            stagger: 0.05,
                            opacity: 1,
                            scrollTrigger: {
                                trigger: char,
                                start: "top 80%",
                                end: "top 30%",
                                scrub: true,
                                toggleActions: "play play reverse reverse",
                            }
                        }
                    );
                });
            }

            var processScrollItemsAnimationTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: processItemsContainer,
                    start: "top +=80%",
                    end: "bottom bottom"
                },
            });

            var itemsAnimationProps = {
                y: 20,
                opacity: 0,
                duration: 0.2,
                ease: "power3.inOut",
                stagger: 0.2
            };

            processScrollItemsAnimationTimeline.from(processItems, itemsAnimationProps);
        }

        initProcessScrollAnimation();
    });
});
